module.exports = __webpack_public_path__ + "laserove-beleni-zubu_1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/special/laserove-beleni-zubu_1.jpg
// module id = 909
// module chunks = 0